import { render, staticRenderFns } from "./TaskChecklist.vue?vue&type=template&id=4dc11346&scoped=true"
import script from "./TaskChecklist.vue?vue&type=script&lang=js"
export * from "./TaskChecklist.vue?vue&type=script&lang=js"
import style0 from "./TaskChecklist.vue?vue&type=style&index=0&id=4dc11346&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dc11346",
  null
  
)

export default component.exports